import C from '../../../constants';

export const involvement = (state = {}, action) => {
    switch (action.type) {
        case C.SET_OWNER_INVOLVEMENT:
            let newState = Object.assign({}, state);
            newState[action.payload.key] = action.payload.value;
            return newState;

        default :
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/containers/owner/reducers/involvementReducer.js